import { createAction } from '@reduxjs/toolkit';

export const requestCreateAccountabilityTemplate = createAction('request/createAccountabilityTemplate');
export const requestViewAccountabilityTemplate = createAction('request/viewAccountabilityTemplate');
export const requestUpdateAccountabilityTemplate = createAction('request/updateAccountabilityTemplate');
export const requestGenerateAccountabilityTemplateSessions = createAction(
  'request/generateAccountabilityTemplateSessions'
);
